import React from 'react';

import {
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { forgotPassword } from '../thunk';

import TextFieldComp from '@/components/TextFieldComp';
import { userSlice } from '@/domain/user/redux';
import { Email } from '@/domain/user/service/entity/valueObjects/email';

const Request: React.FC = () => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<{ username: string }>({
    defaultValues: {
      username: '',
    },
  });
  const onSubmit = (input: { username: string }) => {
    dispatch(forgotPassword(input.username));
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2 style={{ textAlign: 'center' }}>
        パスワードのリセット
      </h2>
      <TextFieldComp
        type="text"
        control={control}
        name="username"
        label="ユーザーID/メールアドレス"
        placeholder={Email.placeholder}
        rules={{
          required: '必須項目です',
        }}
        errors={errors}
      />
      <div style={{ textAlign: 'center', fontSize: '0.8em' }}>
        ユーザーIDもしくはメールアドレスを入力し「認証コードを送る」ボタンを押してください。
      </div>
      <div style={{ textAlign: 'center', margin: '10px 0' }}>
        <Button
          size="large"
          type="submit"
          variant="contained"
          color="primary"
        >
          認証コードを送る
        </Button>
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button size="small" onClick={() => dispatch(userSlice.actions.setMode('signin'))}>
          ログイン画面へ
        </Button>
      </div>
    </form>
  );
};

export default Request;
